/**
 * Step for generate top filter options.
 */
export const TOP_STEP_VALUE = 5;

export const MINI_TOP_STEP_VALUE = 3;

/**
 * 10 is empirically select a number to calculate the height of the bars...
 */
export const BAR_FACTOR = 10;
